import { Button } from '@progress/kendo-react-buttons';
import { DuplicateOutline } from '../../icons/icons';

export default function CopyToClipboardButton(props: { getText?: () => string | null; className?: string }) {
    const handleOnClick = () => {
        if (!props.getText) {
            return;
        }
        const text = props.getText();
        if (text) {
            navigator.clipboard.writeText(text).then();
        }
    };

    return (
        <Button onClick={handleOnClick} svgIcon={DuplicateOutline} fillMode={'outline'} className={props.className}>
            Copy to clipboard
        </Button>
    );
}
